import { render } from "./CptPage.vue?vue&type=template&id=ded42af0&scoped=true"
import script from "./CptPage.vue?vue&type=script&lang=js"
export * from "./CptPage.vue?vue&type=script&lang=js"

import "./CptPage.vue?vue&type=style&index=0&id=ded42af0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ded42af0"]])

export default __exports__